var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 0.833374H3.83332C1.93707 0.833374 0.43374 2.35379 0.43374 4.25004L0.416656 24.75C0.416656 26.6463 1.93707 28.1667 3.83332 28.1667H31.1667C33.0629 28.1667 34.5833 26.6463 34.5833 24.75V4.25004C34.5833 2.35379 33.0629 0.833374 31.1667 0.833374ZM31.1667 24.75H3.83332V14.5H31.1667V24.75ZM31.1667 7.66671H3.83332V4.25004H31.1667V7.66671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.53b0be1fc3778a92333c1497ab040b0a.svg";
export { ForwardRef as ReactComponent };